export const LINK_SETTINGS = 'hsLink';
export const hslinkConfig = {
  ALLOW_ANCHOR_LINKS: 'allowAnchorLinks',
  ALLOW_EMAIL_WEB_VERSION_LINK: 'allowEmailWebVersionLink',
  ALLOW_FILE_DOWNLOAD: 'allowFileDownload',
  ALLOW_MEETING_LINKS: 'allowMeetingLink',
  ALLOW_RAW_LINKS_ONLY: 'allowRawLinksOnly',
  ALLOW_RELATIVE_LINKS: 'allowRelativeLinks',
  EMAIL_SUBSCRIPTION_LINK_TYPES: 'emailSubscriptionLinkTypes',
  SUBSCRIPTION_TYPE_NAME: 'subscriptionTypeName',
  GATES: 'gates',
  HIDE_TARGET_BLANK_AND_NO_FOLLOW: 'hideTargetBlankAndNoFollow',
  OMIT_DOMAIN_REWRITE_ATTR: 'omitDomainRewriteAttr'
};
export const savedLinkFields = {
  HREF: 'href',
  TEXT: 'linkText',
  REL: 'rel',
  TARGET: 'target',
  DOMAIN_REWRITE_ATTR: 'data-hs-domain-rewrite'
};
export const LINK_SHORTCUT = 'Meta+K';
export const LINK_TARGET_BLANK_KEY = '_blank';